<template>
  <div class="zt-autocomplete w-full relative" :class="[autocompleteClasses]">
    <div
      v-if="props.prependIcon"
      class="zt-autocomplete-prepended-icon flex justify-center"
    >
      <zt-icon :name="props.prependIcon" />
    </div>
    <input
      class="zt-autocomplete-input w-full pl-0 pr-5 cursor-pointer"
      ref="ztInputSelect"
      v-model="textInput"
      :class="[
        {
          'zt-autocomplete-input-disabled': isDisabled,
          'zt-autocomplete-input-prepended-icon': props.prependIcon.length
        },
        gtmClass
      ]"
      @input="filterItems()"
      @click.stop
      @keypress.enter="evt => selectPreSelectedChoice(evt)"
      @keydown="evt => changePreSelectedItem(evt)"
      placeholder=" "
      v-bind="$attrs" v-on="$listeners" @focus="_onFocus" @blur="_onBlur" @click="_onClick"
      :id="componentId"
      :aria-owns="computedOwns"
    />
    <label
      :for="componentId"
      class="zt-autocomplete-label pl-0 text-zt-md pointer-events-none"
      :class="[labelClasses]"
      >{{ props.label }}</label
    >
    <div
      v-if="!props.outlined"
      class="zt-autocomplete-underline border-b border-zt-dark-500 pointer-events-none"
      :class="{ 'zt-autocomplete-underline-disabled': isDisabled }"
    ></div>
    <div
      v-if="clearable && isItemSelected"
      class="absolute text-lg zt-autocomplete-icon clearable"
      :class="[{ 'zt-input-icon-disabled': isDisabled }]"
      @click="clearItemSelected()"
    >
      <zt-icon name="times" class="pointer-events-none" />
    </div>
    <transition name="select-content">
      <div
        v-show="
          isActiveContent &&
            (textInput.length >= props.searchCharacter || props.noSearchText)
        "
        ref="ztAutocompleteOptions"
        class="zt-autocomplete-content rounded absolute inline-block overflow-y-auto overflow-x-hidden"
        :style="cordsContent"
        :id="computedOwns"
      >
        <div class="zt-autocomplete-list-box block bg-white py-3 static">
          <div v-if="filteredItems.length > 0">
            <zt-option
              v-for="(item, index) of filteredItems"
              :key="index"
              :itemPreSelected="itemPreSelected"
              :item="item"
              :prepend-icon="props.itemPrependIcon.length ? props.itemPrependIcon : ''"
              @select="optionSelected"
              :parentSelectValue="selectedValue"
            />
          </div>
          <div v-else class="px-4 text-xs text-gray-500">
            <span
              v-if="
                textInput.length < props.searchCharacter && props.noSearchText && !isLoading
              "
            >
              {{ props.noSearchText }}
            </span>
            <span
              v-else-if="
                props.apiSearch && isLoading && textInput.length >= props.searchCharacter
              "
              class="inline-flex items-center"
            >
              <i :class="[loaderTextColor]" class="zt-autocomplete-loader"></i>
              {{ props.loaderTxt }}
            </span>
            <span v-else>{{ props.noResultsText }}</span>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'ztAutocomplete',
  inheritAttrs: false,
}
</script>


